import { useWindowDimensions, View } from 'react-native';
import { ImageLoadingPlaceholder } from '../../image-loading-placeholder/ImageLoadingPlaceholder';
import { useEffect, useState } from 'react';
import TextLato from '../../text/text-lato/TextLato';
import { style } from './PageLoaderElement.native.styles';

export const PageLoaderElement = ({ sentences, showSentence = false }: { sentences: string[]; showSentence?: boolean }) => {
  const [sentenceIndex, setSentenceIndex] = useState(0);
  const { height: windowHeight } = useWindowDimensions();

  useEffect(() => {
    if (showSentence) {
      let index = 0;
      const interval = setInterval(() => {
        index += 1;
        if (!!sentences[index]) setSentenceIndex(index);
      }, 5000);
      return () => clearInterval(interval);
    }
    return;
  }, []);
  return (
    <View style={[style.pageWrapper, { height: windowHeight }]}>
      <View style={style.imageLoadingPlaceholderContainer}>
        <ImageLoadingPlaceholder />
        <View style={style.sentencesContainer}>
          <TextLato style={style.sentencesText}>{sentences[sentenceIndex]}</TextLato>
        </View>
      </View>
    </View>
  );
};
